'use client';

import { type ReactNode } from 'react';
import { InfoIcon } from 'assets/icons';
import { useModal } from 'components/shared/Modal';
import styles from './Section.module.css';

export type SectionProps = {
  id?: string;
  title?: ReactNode;
  subtitle?: ReactNode;
  info?: { content: ReactNode; ariaLabel?: string };
  className?: string;
  children: ReactNode;
};

export const Section = ({
  id,
  title,
  subtitle,
  info,
  className,
  children,
}: SectionProps) => {
  const modal = useModal();

  const openInfoModal = () => {
    if (!info) return;
    modal.set(info.content);
    modal.show();
  };

  return (
    <section
      id={id}
      className={className ? `${styles.container} ${className}` : styles.container}
      aria-labelledby={id ? `${id}-title` : undefined}
    >
      {(title || subtitle || info) && (
        <div className={styles.header}>
          <div className={styles.titles}>
            {title ? <h3 id={id ? `${id}-title` : undefined}>{title}</h3> : null}
            {subtitle ? <p>{subtitle}</p> : null}
          </div>
          {info ? (
            <button
              type="button"
              className={styles.infoButton}
              onClick={openInfoModal}
              aria-label={info.ariaLabel ?? 'More information'}
            >
              <InfoIcon fill="#000" />
            </button>
          ) : null}
        </div>
      )}
      {children}
    </section>
  );
};
